<template>
  <div>
    <v-container fluid>
      <material-card icon="mdi-clipboard-text" inline :title="getTitle">
        <v-card-actions>
          <router-link slot="right" :to="{ name: 'manageSop' }">
            <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>Back</v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form autocomplete="off" @submit.prevent="saveFolderData(id)">
            <v-row>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">
                  Name
                  <span class="require error--text">*</span>
                </label>
                <v-text-field class="my-0 py-1" required placeholder="Enter Section Name" title="Enter valid section name" v-model="name" maxlength="100" readonly></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <label class="font-weight-medium body-2">Access Level </label>
                 <v-select class="my-1 py-0" placeholder="--SELECT" :items="rolesList" v-model="userObj.accessibleTo" light multiple item-text="roleName" item-value="id" return-object>
                  <template v-slot:selection="{ item }">
                    <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                      <span>{{ item.roleName }}</span>
                    </v-chip>
                  </template>
                </v-select>
              </v-col>
               <v-col cols="12" right>
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" type="submit">
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
                </v-col>
             </v-row>
          </form>
          <v-row>
              <v-col cols="12" md="2">
                <label class="font-weight-medium body-2">Files</label>
              </v-col>
              <v-col cols="12" md="10">
                <v-data-table :headers="headers" :items="lists" disable-pagination :hide-default-footer="true">

                  <template v-slot:[`item.roleFileName`] ="{ item }" >
                       <span class="text-capitalize" v-for="(file, i) in item.roleFileName" :key="i"> {{ file }}</span>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn class="px-2 ml-1 ma-1" color="error" min-width="0" small v-if="!item.deletedAt" @click="deleteSopFile(id, item)">
                      <v-icon small> mdi-delete</v-icon>
                      <!--<v-icon small v-else>mdi-restore</v-icon>-->
                    </v-btn>
                    <v-btn class="px-2 ml-1 ma-1" color="success" min-width="0" small  @click="editFile(item)">
                      <v-icon small> mdi-notebook-edit-outline</v-icon>
                    </v-btn>

                  </template>
                  <template v-slot:no-data>
                    <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
                  </template>
                </v-data-table>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn bottom right elevation="1" color="primary" @click="modalOpen('upload')">
                    <v-icon left>mdi-plus</v-icon>
                    Add File
                  </v-btn>
                </v-card-actions>
              </v-col>
              </v-row>
           <v-dialog
          v-model="addModalOk"
          :width="isUpload ? '500px' : '500px'"
          :active="addModalOk"
          :on-cancel="
            () => {
              ;(addModalOk = false), (folderName = ''), (dropFile = [])
            }
          "
        >
          <div v-if="isUpload">
            <form action="modal-card-body">
              <v-card width="500px">
                <v-card-text>
                  <v-row>
                    <v-col cols="12">
                      <label class="label">
                        {{ inputTitle }}
                        <span class="require has-text-danger">*</span>
                      </label>

                      <span class="has-text-danger">Allowed file type: .pdf only. </span>
                      <span class="has-text-danger">Max file size: 50MB each. </span>
                      <span class="has-text-danger">File's that are not supported will be removed automatically!</span>
                    </v-col>
                    <v-col cols="12">
                      <v-file-input accept=".pdf" label="Click to upload" clear-icon="mdi-close" multiple required outlined
                      placeholder="Click to upload" v-model="dropFile" @change="onFilechange()"></v-file-input>
                      <span v-if="dropFile.length > 0">
                        <div class="tags">
                          <span class="tag is-primary" v-for="(file, i) in dropFile" :key="i">
                            {{ file.name }} <button class="delete is-small" type="button" @click="deleteDropFile(i)"></button>
                          </span>
                        </div>
                      </span>
                    </v-col>
                    <v-col cols="12">
                           <div class="field pb-0 mb-0">
                    <label class="font-weight-medium body-2">
                      Roles
                      <span class="require has-text-danger">*</span>
                    </label>
                   <v-select class="my-1 py-0" placeholder="--SELECT"  v-model="selectedFileRoles" :items="selectedRolesLists" light multiple item-text="roleName" item-value="id">

                </v-select>
                  </div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                  <v-btn
                    @click="
                      () => {
                        ;(addModalOk = false), (dropFile = [])
                      }
                    "
                  >
                    Close
                  </v-btn>
                  <v-btn color="primary" @click="uploadNow()">Upload File</v-btn>
                </v-card-actions>
              </v-card>
            </form>
          </div>

        </v-dialog>
        <v-dialog v-model="editModalOk" width="600px" :active="editModalOk" :on-cancel="
        () => {;(editModalOk = false), closeEdit()}">
      <form>
        <v-card>
          <v-toolbar dark color="darkblue">
            <v-toolbar-title>Edit File</v-toolbar-title>
          </v-toolbar>
          <v-card-text v-if="editFileData">
            <v-col cols="12" md="12">
                <label class="font-weight-medium body-2">Access Level </label>
                 <v-select class="my-1 py-0" placeholder="--SELECT" :items="selectedRolesLists"
                 v-model="editFileData.roleFileId" light multiple item-text="roleName" item-value="id">
                    <template v-slot:selection="{ item }">
                      <v-chip small dark class="font-weight-medium" color="darkblue lighten-1">
                        <span>{{ item.roleName }}</span>
                     </v-chip>
                    </template>
                </v-select>

              </v-col>

          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="() => {;(editModalOk = false), (editFileData.roleFileId = ''), closeEdit()}">Close </v-btn>
            <v-btn color="primary" @click="saveSopFile()">Submit</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </div>
</template>
<script>
// import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
// import Multiselect from 'vue-multiselect'
// import moment from 'moment'

import _ from 'lodash'

export default {
  name: 'addRoles',
  components: {
    // CardComponent,
    MaterialCard
    // Multiselect
  },

  props: ['id'],
  // checkable: {
  //   type: Boolean,
  //   default: false
  // }

  data () {
    return {
      isLoading: false,
      getTitle: 'Edit Section',
      isActive: false,
      roles: [],
      files: [],
      lists: [],
      selectedRoles: [],
      roleName: '',
      rolesList: [],
      selectedRolesLists: [],
      selectedRoleId: [],
      selectedFileRoles: [],
      name: '',
      resultArray: [],
      loadingComponent: null,
      isUpload: false,
      fileName: '',
      dropFile: [],
      editModalOk: false,
      inputTitle: "Select file('s)",
      addModalOk: false,
      allowedFiles: ['pdf'],
      editFileId: '',
      userObj: {
        accessibleTo: []
      },
      fileDeleteList: {
        id: '',
        isActive: ''
      },
      editFileData: '',
      headers: [
        { text: 'Files', value: 'fileName', sortable: true },
        { text: 'Access Level', value: 'roleFileName', sortable: true },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },

  async created () {
    await this.getRoleList()
    await this.getFolderItem(this.id)
  },
  beforeDestroy () {
    let elements = document.getElementsByClassName('vuedl-layout__closeBtn')
    if (elements.length > 0) {
      elements[0].click()
    }
  },
  methods: {
    getFolderItem: async function (id) {
      try {
        this.isLoading = true
        if (id) {
          const res = await http.get(`${constants.API_URL}/api/sop-module/folder/${id}`)
          this.name = res.data.name
          if (res.data.accessFolderLevel) {
            this.folderAccess = res.data.accessFolderLevel.map(item1 => {
              let temp = {
                roleName: item1.accessLevel[0].roleName,
                id: item1.sopAccessID
              }
              this.selectedRolesLists.push(temp)
              this.userObj.accessibleTo.push(temp)
            })
            this.selectedRolesLists = _.uniqBy(this.selectedRolesLists, 'id')
            this.userObj.accessibleTo = _.uniqBy(this.userObj.accessibleTo, 'id')
            // console.log(this.selectedRolesLists, 'test25')
            this.lists = res.data.files.map(item => {
              item.roleFileName = []
              item.roleFileId = []
              item.fileAccessDetails.map(row => {
                row.accessLevel.map(row1 => {
                  item.roleFileName.push(row1.roleName)
                  // console.log(row1, 'Row value')
                  item.roleFileId.push(row.sopAccessID)
                })
              })
              return item
            })

            // console.log(this.lists, 'testing3')

            return this.files
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },

    saveFolderData: async function (id) {
      try {
        this.isLoading = true
        await http.put(`${constants.API_URL}/api/sop-module/edit/${id}`, {
          accessibleTo: this.userObj.accessibleTo.map(item => {
            return {
              sopAccessID: item.id || item
            }
          })
        })
        console.log(this.selectedRolesLists, 'before')
        this.selectedRolesLists = this.userObj.accessibleTo
        // console.log(this.selectedRolesLists, 'after')

        this.okMsg('Folder updated successfully!')

        this.getRoleList()
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    deleteSopFile: async function (folderid, fileData) {
      this.$dialog.error({
        title: 'Delete File ?',
        text: 'Do you want to delete this file?',
        actions: {
          false: {
            text: 'No'
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                this.isLoading = true
                let fileDeleteList = {
                  id: fileData.id,
                  isActive: !fileData.isActive
                }

                await http.put(`${constants.API_URL}/api/sop-module/file/delete/${folderid}`,
                  fileDeleteList)

                this.okMsg('File deleted successfully!')
                await this.getFolderItem(this.id)
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              } finally {
                this.isLoading = false
              }
            }
          }
        }
      })
    },

    uploadNow: async function (id) {
      this.loadingComponent = this.$buefy.loading.open()

      let formData = new FormData()

      for (let i = 0; i < this.dropFile.length; i++) {
        formData.append('file', this.dropFile[i])
      }
      // console.log(this.selectedFileRoles, 'listing')
      formData.append('id', this.id)
      formData.append('isActive', true)
      if (this.selectedFileRoles.length === 0) {
        this.loadingComponent.close()
        return this.$buefy.toast.open({
          message: 'Please select atleast one access level.',
          type: 'is-danger',
          duration: 5000
        })
      }
      formData.append('accessibleTo', this.selectedFileRoles)
      // console.log(this.selectedFileRoles.name, 'test')

      try {
        await http.post(`${constants.API_URL}/api/sop-module/addfiles`, formData)
        this.addModalOk = false
        this.dropFile = []
        this.loadingComponent.close()
        await this.getFolderItem(this.id)
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Saved successfully',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })

        // this.okMsg(`File uploaded successfully`)
        // res.data.map((a) => {
        //   console.log(a.isBoom && a.output.payload.statusCode, 'Staus')
        //   if (a.isBoom && a.output.payload.statusCode === 417) {
        //     this.errMsg(a.output.payload.message)
        //   } else {
        //     this.okMsg(`"${a.name}" uploaded successfully`)
        //   }
        // })

        // this.getFolder(this.folderId, 'fromWatch')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While uploading document: ${errorMessage}`)
      }
      this.loadingComponent.close()
    },
    getRoleList: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(`${constants.API_URL}/api/sop-module/allroles`)
        this.rolesList = data.rows
        this.isLoading = false

        return this.roles
      } catch (e) {
        this.isLoading = false

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching role', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },

    onFilechange () {
      // console.log('test')
      let r = this.dropFile.filter((a, i) => {
        return this.allowedFiles.includes(a.name.split('.').pop())
      })
      this.dropFile = r
      // console.log(this.dropFile, 'test6')
    },

    deleteDropFile (i) {
      this.dropFile.splice(i, 1)
    },
    editFile: async function (fileData) {
      try {
        this.isLoading = true
        this.editFileData = fileData
        this.editModalOk = true
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error While getting file details, ${errorMessage}`)
      }
    },
    closeEdit: async function () {
      this.editModalOk = false
    },
    saveSopFile: async function () {
      // console.log(this.editFileData, 'function called')
      try {
        this.isLoading = true
        if (this.editFileData.roleFileId.length > 0) {
          await http.put(`${constants.API_URL}/api/sop-module/editfile/${this.editFileData.id}`, {
            accessibleTo: this.editFileData.roleFileId.map(item => {
              return {
                sopAccessID: item
              }
            })
          })
          this.selectedRolesLists = this.userObj.accessibleTo
          this.okMsg('File access level updated successfully!')
          this.editModalOk = false
          this.getFolderItem(this.id)
        } else {
          this.$buefy.toast.open({
            message: 'Please select atleast one access level.',
            type: 'is-danger',
            duration: 5000
          })
        }
      } catch (e) {
        this.isLoading = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    modalOpen (mode) {
      this.addModalOk = true
      this.isUpload = mode === 'upload'
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
